<script>
    import "firebase/firestore";
    import { getContext } from 'svelte';

    import { Routes, pushRoute } from '../router';
    import { page, organizationName, organizationSets, userStore } from '../stores';
    import { transformNameToInitials } from '../utils';

    const db = getContext('firebase').getFirebase().firestore();
    let borderColor = 'transparent';
    let backgroundColor = 'transparent';
    let initials = '';

    function onToSettings() {
        pushRoute(Routes.SETTINGS);
    }

    userStore.subscribe((a) => {
        if (a === null) {
            return;
        }
        initials = transformNameToInitials(a.firstName, a.lastName);
        switch (a.organizationID) {
        case 0:
            borderColor = ' #C6302B';
            backgroundColor = '#161616';
            break;
        case 1:
            borderColor = '#FFD200';
            backgroundColor = '#002B5C';
            break;
        default:
            borderColor = 'transparent';
            backgroundColor = 'transparent';
        }
        db.collection('organizations').doc(`${a.organizationID}`).get().then((doc) => {
            if (doc.exists) {
                organizationName.update((n) => doc.data().name);
                organizationSets.update((n) => doc.data().sets);
            }
        }).catch((e) => {
            console.log('Error: ', e);
        });
    });
</script>

<div class="circle" on:click={onToSettings} style={
    'border: 3px solid ' + borderColor + ';'
    + 'background-color: ' + backgroundColor + ';'
}>
    <h6>{initials}</h6>
</div>

<style>
    .circle {
        color: white;
        text-align: center;
        margin: 5px;
        width: 65px;
        height: 65px;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: var(--box-shadow);
    }

    .circle:hover {
        cursor: pointer;
    }

    h6 {
        line-height: 68px;
        font-size: 22px;
    }
</style>
